<script setup="">
import { CloudLightningIcon, CloudOffIcon } from "lucide-vue-next";
import { onMounted, ref } from "vue";

import useWebPush from "@/composables/webpush";

const webPush = useWebPush();
const isSubscription = ref(false);

const toggleSubscription = async () => {
  if (!webPush.isAvailable()) {
    alert("웹 푸시를 지원하지 않는 브라우저입니다.");
    return false;
  }

  if (isSubscription.value) {
    if (confirm("푸시를 비활성화 하면 디비 수신 알림을 받을 수 없습니다. 계속하시겠습니까?")) {
      await webPush.disablePushNotification();
      isSubscription.value = false;
    }
  } else {
    await webPush.enablePushNotification();
    isSubscription.value = true;
  }
};

onMounted(async () => {
  if ("Notification" in window && Notification.permission === "granted") {
    const subscription = await webPush.getPushSubscription();

    if (subscription) {
      isSubscription.value = true;
    }
  }
});
</script>

<template>
  <button
    v-tippy="{
      content: isSubscription ? '푸시 활성화됨' : '푸시 비활성화됨',
      placement: 'bottom'
    }"
    class="inline-flex h-8 w-8 items-center justify-center rounded-full"
    @click="toggleSubscription"
  >
    <transition
      v-if="!isSubscription"
      enter-active-class="transition-transform duration-200 ease-out absolute origin-top"
      enter-from-class="scale-75"
      enter-to-class="scale-100 static"
    >
      <CloudOffIcon class="h-5 w-5 text-rose-600" />
    </transition>
    <transition
      v-else
      enter-active-class="transition-transform duration-200 ease-out absolute origin-top"
      enter-from-class="scale-75"
      enter-to-class="scale-100 static"
    >
      <CloudLightningIcon class="h-5 w-5 text-green-600" />
    </transition>
  </button>
</template>
